/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type { WebhooksControllerHandleCalendarEventsWebhookV1Params, WebhooksControllerHandleCallRecordsWebhookV1Params } from '../models';

@Injectable({ providedIn: 'root' })
export class TeamsWebhooksService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Microsoft Graph callback: validation handshake + call-records notifications
   */

  handleCallRecordsWebhook<TData = void>(params?: WebhooksControllerHandleCallRecordsWebhookV1Params): Observable<TData> {
    return this.http.post<TData>(`/uc-monitoring/v1/webhooks/teams/call-records`, undefined, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * @summary Microsoft Graph callback: validation handshake + room-calendar (events) notifications
   */

  handleCalendarEventsWebhook<TData = void>(params?: WebhooksControllerHandleCalendarEventsWebhookV1Params): Observable<TData> {
    return this.http.post<TData>(`/uc-monitoring/v1/webhooks/teams/calendar-events`, undefined, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
}
